import { CheckCircle } from "@mui/icons-material";
import { Chip } from "@mui/material";
import { useRecordContext, useTranslate } from "react-admin";

import { getProcedureStatusColor } from "../../lib/statusColors";
import { ProcedureRecord } from "../../types/procedure";

interface ProcedureStatusChipProps {
  size?: "small" | "medium";
}

export const ProcedureStatusChip = ({ size = "small" }: ProcedureStatusChipProps) => {
  const record = useRecordContext<ProcedureRecord>();
  const translate = useTranslate();

  if (!record) return null;

  if (record.status === "COMPLETED" && record.acknowledgedAt) {
    return (
      <Chip
        label={translate("Procedure.fields.documentationPublished")}
        color="success"
        size={size}
        icon={<CheckCircle />}
      />
    );
  }

  if (record.status === "COMPLETED" && record.performedEnd) {
    return <Chip label={translate("Procedure.fields.documentationPending")} color="warning" size={size} />;
  }

  return (
    <Chip
      label={translate(`Procedure.fields.status.${record.status}`)}
      color={getProcedureStatusColor(record.status)}
      size={size}
    />
  );
};
